import { Component, OnInit } from '@angular/core';
import { LeadsService } from 'src/app/_service/leads.service';
import { SharedService } from 'src/app/_service/shared.service';

@Component({
  selector: 'app-category-wise-ipd-report-feedback',
  templateUrl: './category-wise-ipd-report-feedback.component.html',
  styleUrls: ['./category-wise-ipd-report-feedback.component.css']
})
export class CategoryWiseIpdReportFeedbackComponent implements OnInit {
  TotalCategorywiseIpdCounts=[];loading:boolean=false;

  constructor(private leadapi:LeadsService,private sharedapi:SharedService,) { }

  ngOnInit(): void {
    this.getCategorywiseAllIpdsCounts();
  }

  async getCategorywiseAllIpdsCounts()
    {
        this.loading=true;
        await this.leadapi.getCategorywiseAllIpdsCounts().subscribe((data:any) => {
          this.loading=false;
            if(data.status)
            {
                this.TotalCategorywiseIpdCounts = data.totalData;
            }else{
                this.TotalCategorywiseIpdCounts = [];
                this.sharedapi.presentToast(data.msg);
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

}
